
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    ASD: "ASD",
    BEI: "BEI",
    LCN: "LCN",
    SNS: "SNS",
    ISN: "ISN",
    CSN: "CSN"
};
